import { ValueOf } from '@/types/typings';

export const PAGE_SIZE = 10;
export const listingsPageSize = 10;
export const citizenshipsPageSize = 25;
export const maxDateRangeLength = 99;
export const lendingUrl = 'https://dvuhmetrovigid.ru';
export const telegramRef = 'https://t.me/twometerguide';
export const vkRef = 'https://vk.com/2meterguide';
export const monthsInCalendar = 12;
export const timeToRefreshDialog = 1000 * 60 * 10;
export const MAX_PRICE = 1_000_000;
export const SCROLLBAR_WIDTH = 16;
export const CARD_HEIGHT = 420;
export const ALL_EXCURSION_CARD_HEIGHT = 275;

export const defaultRating = 4.8;

export const policyLink =
  'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/01_Politika_zashchity_i_obrabotki_PD_red_07.08.2026.docx.pdf';
export const bonusSystemInfoLink =
  'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/11_Polozhenie_o_bonusnoy_programme_NOVAYA_RED.docx.pdf';

export const sideMenuLinks = {
  main: `${lendingUrl}/`,
  tours: '/?bookingType=your-tour',
  rent: '/?bookingType=accommodation',
  excursion: '/all-excursions',
  blog: `${lendingUrl}/blog/`,
  about: `${lendingUrl}/komanda/`,
  contacts: `${lendingUrl}/contact/`,
  docs: '/docs/',
} as const;

export const PersonType = {
  guest: 'guest',
  customer: 'customer',
} as const;

export type PersonType = ValueOf<typeof PersonType>;

export const docs: { title: string; url: string }[] = [
  {
    title: 'docs-page.docs.privacy-policy-teplolive',
    url: policyLink,
  },
  {
    title: 'docs-page.docs.personal-data-consent',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/02_Soglasie_na_obrabotku_PD_red_07.08.2026.docx.pdf',
  },
  {
    title: 'docs-page.docs.mailing-consent',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/03_Soglasie_na_rassylku_red_07.08.2026.docx.pdf',
  },
  {
    title: 'docs-page.docs.recommendation-rules',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/04_Pravila_rekomendatelnykh_tekhnologiy_red_07.08.2026.docx.pdf',
  },
  {
    title: 'docs-page.docs.personal-data-consent-yandex',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/05_Soglasie_Yandex_SmartCaptcha_red_07.08.2026.docx.pdf',
  },
  {
    title: 'docs-page.docs.metrics-consent',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/06_Soglasie_metricheskie_programmy_NOVYY.docx.pdf',
  },
  {
    title: 'docs-page.docs.public-offer',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/07_Oferta_red_07.08.2026.docx.pdf',
  },
  {
    title: 'docs-page.docs.bonus-system-info',
    url: bonusSystemInfoLink,
  },
  {
    title: 'docs-page.docs.personal-data-distribution-consent',
    url: 'https://1a683db7-85e9-4e7f-973f-dc8bd135ccc2.selstorage.ru/12_Soglasie_na_rasprostranenie_PD_NOVYY.docx.pdf',
  },
];
